// src/components/SectionHeader.jsx
import React from "react";
import { Box, Typography } from "@mui/material";

const SectionHeader = ({ kicker, title, subtitle, kickerColor, subtitleColor }) => (
  <Box sx={{ mb: 3 }}>
    <Typography
      variant="overline"
      sx={{ letterSpacing: "0.14em", color: kickerColor || "text.secondary" }}
    >
      {kicker}
    </Typography>
    <Typography variant="h4" sx={{ fontWeight: 600, mt: 0.5 }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography
        variant="body1"
        sx={{ color: subtitleColor || "text.secondary", mt: 1, maxWidth: 640 }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeader;
